<template>
  <div v-if="demoData" class="demo-wrap w-100 d-f fd-c ai-c p bs-bb">
    <div class="d-f ai-c jc-c ai-fe">

      <!-- Artist image -->
      <div class="demo-img p-rel bc-black br-pill">
        <img
          v-if="submittedByProfileImage"
          :src="submittedByProfileImage"
          alt="image"
        />
        <PlaceholderImg v-else width="80%" height="80%" class="p-a pos-center" />
      </div>
      <!-- <h1 class="m-0 flex-1">{{ demoData.title }}</h1> -->
      <!-- <div class="d-f ai-c g">
        <div class="custom-btn b-r-100 d-f ai-c jc-c" @click="openDemo(-1)">
          <IconBase class="rotate-90">
            <IconChevronDown />
          </IconBase>
        </div>
        <h1 class="m-0">
          {{ currentDemoIndex + 1
          }}<span class="mute">{{ `/${demosList.length}` }}</span>
        </h1>
        <div class="custom-btn b-r-100 d-f ai-c jc-c" @click="openDemo(1)">
          <IconBase class="rotate-270">
            <IconChevronDown />
          </IconBase>
        </div>
      </div> -->
    </div>
    <!-- Content block -->
    <div class="content-wrap d-f fd-c m-t bs-bb small-wrap">
      <!-- Left side -->
      <div class="left-side d-f fd-c flex-1 g bs-bb w-100 p-b b-bottom">
        <div class="row-1">
          <!-- Demo details -->
          <div class="details-wrap">
            <div>
              <div class="font-small mute">Title</div>
              <div>{{ this.demoData.title }}</div>
            </div>
            <div>
              <div class="font-small mute">Artist</div>
              <div>{{ this.submittedByProfileName }}</div>
            </div>
            <div>
              <div class="font-small mute">Genres</div>
              <div>{{ this.demoData.genre }}</div>
            </div>
            <div>
              <div class="font-small mute">Uploaded</div>
              <div>
                {{ dateToFormattedD(this.demoData.timestamp) }}
              </div>
            </div>
            <div v-if="demoData.timestamp">
              <div class="font-small mute">Original expires</div>
              <div :class="{ 'expiry-warning': daysUntilOriginalExpiry <= 7 }">
                {{ originalExpiryText }}
              </div>
            </div>
          </div>
        </div>
        <div v-if="demoData.description" class="row-2">
          <p class="font-small mute">Description</p>
          <p class="ta-j">{{ demoData.description }}</p>
        </div>
      </div>
      <!-- Right side -->
      <div class="right-side d-f fd-c flex-1 bs-bb of-h w-100">

        <div class="reviews-row p-b d-f bs-bb w-100 p-t b-bottom jc-c">
          <div class="lt-side d-f flex-1">
            <DemoReviewsList :demo-data="demoData" />
          </div>
          <div class="rt-side d-f ai-c g-half">
            <span v-if="originalExpired" class="font-small mute">Original expired</span>
            <button
              class="download-btn small secondary pill square d-f ai-c jc-c"
              @click="downloadAudio"
              :disabled="!demoData?.url"
              :title="originalExpired ? 'Original file expired — downloading compressed preview' : 'Download original'"
            >
              <IconBase :w="15" :h="15" view-box="0 0 15 15">
                <IconDownload />
              </IconBase>
            </button>
          </div>

        </div>

        <div v-if="lastMessage" class="b-bottom w-100 d-f g p-b ai-c m-t">
          <ImageWithInitials
            :src="lastMessage.profileImage"
            :name="lastMessage.profileName"
            size="30"
          />

          <div class="d-f fd-c flex-1">
            <p class="mute font-small">
              {{ lastMessage.profileName }}&nbsp;<span
                >&nbsp;- <TimestampCountdown :start="lastMessage.timestamp"
              /></span>
            </p>
            <p class="clamp-1">{{ lastMessage.message }}</p>
          </div>

          <button
            class="small br-round ws-nowrap d-f ai-c font-w-medium"
            @click="toggleChat"
          >
            {{ isReceiver ? "Chat" : "Response" }}
            ({{ lastMessage.total }})
            <!-- <IconBase class="rotate-270" color="black" w="15" h="15" viewBox="0 0 15 15" sw="1">
              <IconChevronDown />
            </IconBase> -->
          </button>
        </div>
        <!-- <div v-else class="b-bottom m-t w-100 d-f g p-b ai-c jc-fe">
          <button
            class="small br-round ws-nowrap d-f ai-c font-w-medium"
            @click="toggleChat"
          >
            {{ userType === "artist" ? "Open messages" : "Open chat" }} ({{
              demoMessagesCount
            }})
          </button>
        </div> -->

        <div
          v-if="isReceiver || demoMessagesCount > 0"
          class="b-bottom m-t w-100"
        >
          <ChatInput :demo-data="demoData" @openChat="toggleChat" />
          <!-- <div class="d-f">
              <button
                class="toggle-chat small br-round ws-nowrap d-f ai-c font-w-medium"
                @click="toggleChat"
              >
                {{ userType === "artist" ? "Open messages" : "Open chat" }} ({{
                  demoMessagesCount
                }})
              </button>
          </div> -->
        </div>

        <DemoRatings :demo-data="demoData" :auto-save="true" />

        <p class="m-t">{{ saving ? "Saving..." : "&nbsp;" }}</p>
      </div>
    </div>

    
    <div
      class="action-toolbar bc-black d-f fd-c ai-c jc-c p-f w-100 l-0 bs-bb b-0 g p"
    >
      <div class="waveform-wrap d-f fd-c w-100 ai-c jc-c bs-bb">
        <div class="w-100">
          <AudioWaveformPlayer
            ref="audioPlayer"
            :key="demoData.id"
            class="w-100"
            :src="demoData.url"
            :download-url="demoData.originalUrl || demoData.url"
            :peaks="JSON.parse(demoData.peaks ?? '[]')"
            :duration="demoData.duration"
            :title="demoData.title"
            :height="60"
            @loaded="audioMetaDataLoaded"
            @played="onAudioPlayed"
            @paused="onAudioPaused"
            @downloaded="audioDownloaded"
            @seek-times="seekTimes = $event"
            compact
          />
        </div>
        <div class="track-duration pe-n p-a bc-brand font-small br-pill">{{ seekTimes.current }} / {{ seekTimes.total }} </div>
      </div>
      <div class="d-f w-100 ai-c jc-c g">
        <button class="next secondary pill square d-f ai-c jc-c" @click="openDemo(-1)">
          <IconBase class="rotate-90">
            <IconChevronDown />
          </IconBase>
        </button>
        <div
          class="save-reject-btns d-f jc-c ai-c g flex-1 bs-bb"
        >
          <button
            v-if="isReceiver"
            class="save-btn secondary pill br-lg d-f ai-c jc-c g-half"
            @click="saveDemo"
          >
            <IconBase class="hide-mob" w="15" h="15" viewBox="0 0 15 15" icon-name="save">
              <IconHeartFill v-if="isSaved" />
              <IconHeart v-else />
            </IconBase>
            <span class="tt-up">{{ isSaved ? "Unsave" : "Save" }}</span>
          </button>
          <button
            class="play-btn secondary pill square d-f ai-c jc-c"
            @click="toggleAudioPlay"
            :disabled="!demoData?.url"
          >
            <IconBase w="15" h="15" viewBox="0 0 15 15" icon-name="play">
              <IconPause v-if="audioPlaying" />
              <IconPlay v-else />
            </IconBase>
          </button>
          <button
            v-if="isReceiver"
            class="reject-btn secondary pill br-lg d-f ai-c jc-c g-half"
            @click="rejectDemo"
          >
            <IconBase class="hide-mob" w="15" h="15" viewBox="0 0 15 15" icon-name="cancel">
              <IconCancelCircle />
            </IconBase>
            <span class="tt-up">{{ isRejected ? "Unreject" : "Reject" }}</span>
          </button>
        </div>
        <button class="prev secondary pill square d-f ai-c jc-c" @click="openDemo(1)">
          <IconBase class="rotate-270">
            <IconChevronDown />
          </IconBase>
        </button>
      </div>
    </div>

    <ChatSidebar
      :open="chatOpen"
      :demo="demoData"
      @closed="toggleChat"
      @last-message-update="lastMessageUpdated"
    />
  </div>
  <Loader v-else class="pos-center" />
</template>

<script>
import Loader from "@/components/misc/Loader.vue";
import { mapGetters, mapState } from "vuex";
import PlaceholderImg from "@/assets/icons/PlaceholderImg.vue";
import { dateToFormattedD, formatDuration } from "@/common";
import IconBase from "@/assets/icons/IconBase.vue";
import IconHeart from "@/assets/icons/IconHeart.vue";
import IconPlay from "@/assets/icons/IconPlay.vue";
import IconPause from "@/assets/icons/IconPause.vue";
import IconCancelCircle from "@/assets/icons/IconCancelCircle.vue";
import { rtdb } from "@/db";
import AudioWaveformPlayer from "@/components/misc/AudioWaveformPlayer.vue";
import IconChevronDown from "@/assets/icons/IconChevronDown.vue";
import DemoReviewsList from "@/components/demos/DemoReviewsList.vue";
import IconHeartFill from "@/assets/icons/IconHeartFill.vue";
import ChatSidebar from "@/components/demos/ChatSidebar.vue";
import ChatInput from "@/components/misc/ChatInput.vue";
import * as Utils from "@/utils/demoUtils";
import ImageWithInitials from "@/components/misc/ImageWithInitials.vue";
import DemoRatings from "@/components/demos/DemoRatings.vue";
import TimestampCountdown from "@/components/misc/TimestampCountdown.vue";
import IconDownload from "@/assets/icons/IconDownload.vue";

export default {
  name: "Demo",
  components: {
    TimestampCountdown,
    DemoRatings,
    ImageWithInitials,
    ChatInput,
    ChatSidebar,
    IconHeartFill,
    DemoReviewsList,
    IconChevronDown,
    AudioWaveformPlayer,
    IconCancelCircle,
    IconPause,
    IconPlay,
    IconHeart,
    IconBase,
    PlaceholderImg,
    Loader,
    IconDownload,
  },
  data() {
    return {
      audioDuration: null,
      audioPlaying: false,
      seekTimes: { current: "00:00", total: "00:00" },
      saving: false,
      chatOpen: false,
      lastMessage: null,
    };
  },
  created() {
    this.init();
  },
  methods: {
    dateToFormattedD,
    formatDuration,
    init() {
      console.log("init demo");

      this.listType = this.$route.query.list || this.getInboxTabs.All;
      this.sortBy = this.$route.query.sortBy || "latest";

      this.$nextTick(() => {
        this.updateNavbarTitle();

        if (
          this.listType === this.getInboxTabs.Messages ||
          this.$route.query.openMessages
        ) {
          this.chatOpen = true;

          // Remove the query param to avoid reopening the chat on every route change
          if (this.$route.query.openMessages) {
            const query = { ...this.$route.query };
            delete query.openMessages;

            this.$router.replace({ query });
          }
        }
      });
    },
    audioMetaDataLoaded({ duration }) {
      this.audioDuration = formatDuration(duration);
    },
    updateNavbarTitle() {
      let index = this.currentDemoIndex;

      this.$root.$emit(
        "setNavbarTitle",
        `<span>${this.listType}:&nbsp;${index + 1}&nbsp;/&nbsp;${
          this.demosList.length
        }</span>`
      );
    },

    saveDemo() {
      this.saving = true;
      const newSavedState = !this.isSaved;
      const promises = [this.demoDbSavedRef.set(newSavedState)];

      if (newSavedState && this.isRejected) {
        promises.push(this.demoDbRejectedRef.set(false));
      }

      Promise.all(promises)
        .then(() => {
          const message = newSavedState
            ? "Added to Saved demos list"
            : "Removed from Saved demos list";
          this.$store.dispatch("togglePopMess", message);
          // this.openDemo(1);
        })
        .finally(() => {
          this.saving = false;
        });
    },

    rejectDemo() {
      this.saving = false;
      const newRejectedState = !this.isRejected;
      const promises = [this.demoDbRejectedRef.set(newRejectedState)];

      if (newRejectedState && this.isSaved) {
        promises.push(this.demoDbSavedRef.set(false));
      }

      Promise.all(promises)
        .then(() => {
          const message = newRejectedState
            ? "Added to Rejected demos list"
            : "Removed from Rejected demos list";
          this.$store.dispatch("togglePopMess", message);
          // this.openDemo(1);
        })
        .finally(() => {
          this.saving = false;
        });
    },

    markDemoAsViewed() {
      if (
        this.demoDbViewedRef &&
        this.activeReviewerId &&
        !Utils.isDemoViewedByReviewer(this.demoData, this.activeReviewerId)
      ) {
        return this.demoDbViewedRef.set(true);
      }
    },

    onAudioPlayed() {
      this.audioPlaying = true;
      this.audioPlayed();
    },
    onAudioPaused() {
      this.audioPlaying = false;
    },
    toggleAudioPlay() {
      this.$refs.audioPlayer?.playPause();
    },
    downloadAudio() {
      this.$refs.audioPlayer?.downloadAudio();
      this.audioDownloaded();
    },
    audioPlayed() {
      if (
        this.demoDbPlayedRef &&
        this.activeReviewerId &&
        !Utils.isDemoPlayedByReviewer(this.demoData, this.activeReviewerId)
      ) {
        return this.demoDbPlayedRef.set(true);
      }
    },

    audioDownloaded() {
      if (
        this.demoDbDownloadedRef &&
        this.activeReviewerId &&
        !Utils.isDemoDownloadedByReviewer(this.demoData, this.activeReviewerId)
      ) {
        return this.demoDbDownloadedRef?.set(true);
      }
    },

    openDemo(n) {
      if (this.demosList.length === 0) {
        this.$root.$emit("open-inbox");
        return;
      }

      let newIndex = this.currentDemoIndex + n;

      if (newIndex < 0 || newIndex >= this.demosList.length) {
        alert("No more demos in this list");
        return;
      }

      const newDemo = this.demosList[newIndex];

      if (newDemo) {
        this.$router.push({
          name: "Demo",
          query: this.$route.query,
          params: {
            id: newDemo.id,
          },
        });
      }
    },

    toggleChat() {
      this.chatOpen = !this.chatOpen;
    },

    lastMessageUpdated(message) {
      this.lastMessage = message;
    },
  },
  computed: {
    ...mapState(["userType", "selectedReviewer"]),
    ...mapGetters([
      "getInboxTabs",
      "getDemoById",
      "sortedDemosList",
      "getProfileImageByUid",
      "getProfileNameByUid",
      "isReceiver",
      "activeReviewerId",
    ]),

    listType: {
      get() {
        return this.$store.state.selectedInboxTab;
      },

      set(list) {
        this.$store.dispatch("setSelectedInboxTab", {
          list,
          route: this.$route,
          router: this.$router,
        });
      },
    },

    sortBy: {
      get() {
        return this.$store.state.inboxSortBy;
      },

      set(sortBy) {
        this.$store.dispatch("setInboxSortBy", {
          sortBy,
          route: this.$route,
          router: this.$router,
        });
      },
    },

    demoData() {
      return this.getDemoById(this.$route.params.id);
    },

    demoDbRef() {
      if (!this.demoData) return null;

      return rtdb.ref(`demoSubmissions/${this.demoData.id}`);
    },

    demoMessagesCount() {
      return Object.keys(this.demoData?.messages ?? {}).length;
    },

    demoDbSavedRef() {
      if (!this.isReceiver || !this.demoData || !this.activeReviewerId) return null;
      return this.demoDbRef.child(`saved/${this.activeReviewerId}`);
    },

    demoDbRejectedRef() {
      if (!this.isReceiver || !this.demoData || !this.activeReviewerId) return null;
      return this.demoDbRef.child(`rejected/${this.activeReviewerId}`);
    },

    demoDbViewedRef() {
      if (!this.isReceiver || !this.demoData || !this.activeReviewerId) return null;
      return this.demoDbRef.child(`viewed/${this.activeReviewerId}`);
    },

    demoDbPlayedRef() {
      if (!this.isReceiver || !this.demoData || !this.activeReviewerId) return null;
      return this.demoDbRef.child(`played/${this.activeReviewerId}`);
    },

    demoDbDownloadedRef() {
      if (!this.isReceiver || !this.demoData || !this.activeReviewerId) return null;
      return this.demoDbRef.child(`downloaded/${this.activeReviewerId}`);
    },

    isSaved() {
      if (!this.activeReviewerId) return false;
      return Utils.isDemoSavedByReviewer(this.demoData, this.activeReviewerId);
    },

    isRejected() {
      if (!this.activeReviewerId) return false;
      return Utils.isDemoRejectedByReviewer(this.demoData, this.activeReviewerId);
    },

    demosList() {
      return this.sortedDemosList;
    },

    submittedByProfileImage() {
      return this.getProfileImageByUid(this.demoData.submittedBy);
    },

    submittedByProfileName() {
      return this.getProfileNameByUid(this.demoData.submittedBy);
    },

    currentDemoIndex() {
      return this.demosList.findIndex((d) => d.id === this.demoData?.id);
    },

    daysUntilOriginalExpiry() {
      if (!this.demoData?.timestamp) return 30;
      const submitted = new Date(this.demoData.timestamp).getTime();
      if (isNaN(submitted)) return 30;
      const elapsed = Date.now() - submitted;
      return Math.max(0, 30 - Math.floor(elapsed / (24 * 60 * 60 * 1000)));
    },

    originalExpired() {
      return !this.demoData?.originalUrl && this.daysUntilOriginalExpiry <= 0;
    },

    originalExpiryText() {
      if (!this.demoData?.originalUrl && this.daysUntilOriginalExpiry <= 0) return "Expired";
      const d = this.daysUntilOriginalExpiry;
      if (d === 0) return "Today";
      if (d === 1) return "1 day";
      return `${d} days`;
    },
  },
  watch: {
    selectedReviewer() {},
    userType() {},
    demosList() {
      this.updateNavbarTitle();
    },
    $route() {
      this.init();
    },
    demoData(demoData, oldDemoData) {
      if (demoData && demoData?.id === oldDemoData?.id) {
        return;
      }

      this.audioPlaying = false;

      if (demoData) {
        this.$store.dispatch("cacheUserData", {
          uid: demoData.submittedTo,
        });
        this.$store.dispatch("cacheUserData", {
          uid: demoData.submittedBy,
        });

        this.markDemoAsViewed();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/scss/_variables.scss";
@import "@/scss/_classes.scss";

.demo-wrap {
  margin-top: $nav-height;
  margin-bottom: 200px;
}

.download-btn {
  padding: 4px 0;
}

.expiry-warning {
  color: $red;
}
.demo-img {
    grid-column: span 1;
    width: 140px;
    aspect-ratio: 1 / 1;
    height: auto;
    & > img {
      width: 140px;
      height: auto;
      aspect-ratio: 1 / 1;
      display: block;
      vertical-align: top;
    }
  }
.row-1 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: $mg-desktop;
  .details-wrap {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: $mg-desktop;
    grid-column: span 2;

    div {
      display: flex;
      flex-direction: column;
    }
  }
}
.action-toolbar {
  .track-duration {
    padding: 4px 8px;
  }
  .save-reject-btns {
    .save-btn, .reject-btn {
      min-width: 200px;
    }
  }
}
@media #{$mobile} {
  .action-toolbar {
    padding: $mg-desktop;
    .next, .prev {
      // border: none !important;
      min-width: 33px;
      width: 33px;
      height: 33px;
    }
    .save-reject-btns {
      .save-btn, .reject-btn {
          min-width: 50px;
          flex: 1;
          height: 33px;
          padding: 0;
      }
    }
  }
}


.send-btn {
  width: 30px;
  height: 30px;
}
</style>

